import { Link } from "react-router-dom";

export const AdmissionProcessDistanceLearningConst = {
  path: "/single-page/admisision-process-distance-learning",
  title: "ПРОЦЕСС ПОСТУПЛЕНИЯ НА ДИСТАНЦИОННУЮ ФОРМУ",
  contentJSX: (
    <>
      <p>
        <strong>Malta School of Medicine & Business</strong> стремится сделать дистанционное обучение максимально доступным и понятным. Мы
        упростили процесс поступления до 4 шагов, чтобы каждый абитуриент чувствовал уверенность и поддержку на всех этапах. Наша приёмная
        комиссия всегда готова проконсультировать вас по email, телефону или в мессенджерах.
      </p>
      <br />
      <p>Пожалуйста, ознакомьтесь с пошаговой инструкцией и свяжитесь с нами, если у вас останутся вопросы.</p>
      <br />
      <Link to={"/apply-online"} className="btn-default reverse">
        Оставить заявку
      </Link>
      <h2>ШАГ 1. ПОДАЧА ЗАЯВКИ</h2>
      <p>
        Выберите интересующую вас программу из списка <strong>Malta School of Medicine & Business</strong> и заполните онлайн-заявку на
        сайте. Также вы можете направить свои документы по электронной почте.
      </p>
      <br />
      <p>
        <strong>Необходимые документы для получения Письма о зачислении:</strong>
      </p>
      <ul>
        <li>Копия загранпаспорта или удостоверения личности (срок действия не менее 2 лет);</li>
        <li>Аттестат о среднем образовании с приложением;</li>
        <li>Диплом бакалавра с транскриптом (только для поступающих на магистратуру);</li>
        <li>Заполненная форма заявки.</li>
      </ul>
      <p>Рассмотрение документов занимает до 2 рабочих дней.</p>
      <h2>ШАГ 2. ПОЛУЧЕНИЕ ПИСЬМА О ЗАЧИСЛЕНИИ</h2>
      <p>
        После рассмотрения ваших документов вы получите <strong>Письмо о возможности зачисления</strong>, содержащее информацию о выбранной
        вами программе, структуре оплаты и организационных деталях вашего обучения в <strong>Malta School of Medicine & Business.</strong>
      </p>
      <br />
      <p>Если после получения письма у вас появятся вопросы, приёмная комиссия предоставит всю необходимую дополнительную информацию.</p>
      <h2>ШАГ 3. РЕГИСТРАЦИЯ И ОПЛАТА</h2>
      <p>
        Следующим шагом станет <strong>оплата обучения за первый год,</strong> согласно информации в Письме о зачислении. В письме будут
        указаны банковские реквизиты, и при необходимости мы предоставим отдельный счёт-фактуру.
      </p>
      <h2>ШАГ 4. НАЧАЛО ОБУЧЕНИЯ</h2>
      <p>
        После подтверждения оплаты вы будете официально зачислены в <strong>Malta School of Medicine & Business.</strong> Вам будет открыт
        доступ к личному онлайн-кабинету, где вы найдёте индивидуальную программу обучения, учебные материалы, расписание и лекции.
      </p>
      <br />
      <Link to={"/apply-online"} className="btn-default reverse">
        Оставить заявку
      </Link>
      <br />
      <p>
        Мы будем рады видеть вас среди наших студентов! <br />
        Станьте частью международного образовательного сообщества
        <strong> Malta School of Medicine & Business!</strong>
      </p>
    </>
  ),
  contentSearch: `
    Malta School of Medicine & Business стремится сделать дистанционное обучение максимально доступным и понятным. Мы упростили процесс поступления до 4 шагов, чтобы каждый абитуриент чувствовал уверенность и поддержку на всех этапах. Наша приёмная комиссия всегда готова проконсультировать вас по email, телефону или в мессенджерах.
    Пожалуйста, ознакомьтесь с пошаговой инструкцией и свяжитесь с нами, если у вас останутся вопросы.
    ШАГ 1. ПОДАЧА ЗАЯВКИ
    Выберите интересующую вас программу из списка Malta School of Medicine & Business и заполните онлайн-заявку на сайте. Также вы можете направить свои документы по электронной почте.
    Необходимые документы для получения Письма о зачислении:
    Копия загранпаспорта или удостоверения личности (срок действия не менее 2 лет);
    Аттестат о среднем образовании с приложением;
    Диплом бакалавра с транскриптом (только для поступающих на магистратуру);
    Заполненная форма заявки.
    Рассмотрение документов занимает до 2 рабочих дней.
    ШАГ 2. ПОЛУЧЕНИЕ ПИСЬМА О ЗАЧИСЛЕНИИ
    После рассмотрения ваших документов вы получите Письмо о возможности зачисления, содержащее информацию о выбранной вами программе, структуре оплаты и организационных деталях вашего обучения в Malta School of Medicine & Business.
    Если после получения письма у вас появятся вопросы, приёмная комиссия предоставит всю необходимую дополнительную информацию.
    ШАГ 3. РЕГИСТРАЦИЯ И ОПЛАТА
    Следующим шагом станет оплата обучения за первый год, согласно информации в Письме о зачислении. В письме будут указаны банковские реквизиты, и при необходимости мы предоставим отдельный счёт-фактуру.
    ШАГ 4. НАЧАЛО ОБУЧЕНИЯ
    После подтверждения оплаты вы будете официально зачислены в Malta School of Medicine & Business. Вам будет открыт доступ к личному онлайн-кабинету, где вы найдёте индивидуальную программу обучения, учебные материалы, расписание и лекции. 
    Мы будем рады видеть вас среди наших студентов!
    Станьте частью международного образовательного сообщества Malta School of Medicine & Business!
  `,
};
